import { Period, PeriodTypeDay } from "@dto/period";
import { TW_FilterEditorPeriodInput } from "@utils/twClasses";
import { isoDateRegex } from "@utils/types";
import { memo, useEffect, useState } from "react";
import { PeriodEditionFormProps } from "./PeriodCell";

export const PeriodDayEditionForm = memo(function PeriodDayEditionForm({ field, value, updatePeriod, searchValue, setSearchValue, searchInputRef, displaySearch = true, hasValidation = true, disabled = false }: PeriodEditionFormProps) {

    const [text, setText] = useState<string | null>(null);
    const [timer, setTimer] = useState<NodeJS.Timeout | undefined>(undefined);
    const VALIDATION_DELAY = 1000;

    useEffect(() => {
        if (value) {
            const period = Period.fromObject(value);
            setText(period?.isoDate() || "");
        } else {
            setText(null);
        }
    }, [value]);

    const updateLocalValue = (value: any) => {
        const period = Period.fromObject(value);
        setText(period?.isoDate() || "");
        updatePeriod(value);
    }

    const textToValue = (text: string | null): any => {
        if (!text || text.length === 0) {
            return null;
        }
        try {
            if (isoDateRegex.test(text)) {
                return Period.create(text, PeriodTypeDay);
            }
        } catch (error) {
            console.error("period text is not valid: ", text, error);
        }
        return null;
    }

    function isTextValid(value: string | null) {
        return true;
    }

    function validate(value: string | null) {
        if (isTextValid(value)) {
            updateLocalValue(textToValue(value));
        }
    }

    function onEnterKeyPressEditing(event: React.KeyboardEvent) {
        if (disabled) {
            return;
        }
        switch (event.key) {
            case "Enter":
                event.preventDefault();
                event.stopPropagation();
                validate(text);
                
                break;
            default:
                return;
        }
    }

    function onTextChange(event: React.ChangeEvent<HTMLInputElement>) {
        let value = event.target.value;
        if (isTextValid(value)) {
            setText(value);
            clearTimeout(timer);

            const newTimer = setTimeout(() => {
                validate(value);
            }, VALIDATION_DELAY);

            setTimer(newTimer);
        } else {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    return (
        <input
            className={TW_FilterEditorPeriodInput + (disabled ? " cursor-not-allowed opacity-60" : " cursor-pointer")}
            type="date"
            value={text ?? ""}
            onChange={onTextChange}
            onKeyDown={onEnterKeyPressEditing}
            autoFocus={true}
            disabled={disabled}
        />
    )
}, (prevProps, nextProps) => {
    return prevProps.field === nextProps.field && prevProps.value === nextProps.value && prevProps.searchValue === nextProps.searchValue && prevProps.searchInputRef === nextProps.searchInputRef && prevProps.disabled === nextProps.disabled;
});